import React from "react";
import { Box, useTheme, Radio, RadioGroup, FormControl, FormControlLabel, Tooltip, Typography, IconButton } from "@mui/material";
import AxionControls from "../../../components/controls/AxionControls";
import Checkbox from "../../../components/controls/Checkbox";
import Button from "../../../components/controls/Button";
import { tokens } from "../../../assets/theme";
import messages from "./messages";
import { FormattedMessage, useIntl } from "react-intl";
import InfoIconOutlined from '@mui/icons-material/InfoOutlined';

export default function ReadingThresholdDialog(props) {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { formatMessage } = useIntl();

    const handleChange = (event) => {
        const { id, name, value, type, checked } = event.target
        props.setReadingThresholds(prev => {
            return {
                ...prev,
                [id ? id : name]: type === "checkbox" ? checked : type === "radio" ? value === "true" : value
            }
        })
    }

    const handleChangeSelect = (event) => {
        const { name, value } = event.target

        let valueToSet = value === "" ? null : value;
        props.setReadingThresholds(prev => {
            return {
                ...prev,
                [name]: valueToSet
            }
        })
    }

    return (
        <Box
            sx={{
                p: 1,
                m: 1
            }}>
            <Box>
                <Checkbox
                    name="enableHighLimit"
                    label={<FormattedMessage {...messages.enableHighLimit} />}
                    value={props.readingThresholds.enableHighLimit}
                    onChange={handleChange}
                /><br />
                <AxionControls.AxionTextBox
                    name="highLimitValue"
                    label={<FormattedMessage {...messages.highLimitValue} />}
                    sx={{
                        mt: -2,
                        mb: 1
                    }}
                    value={props.readingThresholds.highLimitValue}
                    disabled={!props.readingThresholds.enableHighLimit}
                    onChange={handleChange}
                />
                <AxionControls.AxionSelect
                    //readOnly={props.recurringSchedule.id > 0}
                    showNoneOption={true}
                    noneText="Ingen vald"
                    noneValue={null}
                    size="small"
                    name="highLimitInstructionId"
                    disabled={!props.readingThresholds.enableHighLimit}
                    value={props.readingThresholds.highLimitInstructionId || ""}
                    label={<FormattedMessage {...messages.highLimitInstruction} />}
                    onChange={handleChangeSelect}
                    options={props.instructionsResult}
                />
                <AxionControls.AxionTextBox
                    name="highLimitMinutesOverThreshold"
                    label={<FormattedMessage {...messages.highLimitMinuetesOverThreshold} />}
                    value={props.readingThresholds.highLimitMinutesOverThreshold}
                    disabled={!props.readingThresholds.enableHighLimit}
                    onChange={handleChange}
                />
                <Checkbox
                    name="highLimitCheckMachineInStatus"
                    label={<FormattedMessage {...messages.highLimitCheckMachineInStatus} />}
                    value={props.readingThresholds.enableHighLimit && props.readingThresholds.highLimitCheckMachineInStatus}
                    onChange={handleChange}
                />
                <FormControl 
                    disabled={!props.readingThresholds.highLimitCheckMachineInStatus}
                    sx={{
                        mb: 2
                    }}>
                    <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="highLimitMachineInRunningStatus"
                        value={!props.readingThresholds.highLimitCheckMachineInStatus ? "" : props.readingThresholds.highLimitMachineInRunningStatus}
                        onChange={handleChange}
                    >
                        <FormControlLabel
                            value="true"
                            control={<Radio sx={{
                                color: "secondary",
                                '&.Mui-checked': {
                                color: colors.dashbordGreen[500],
                                },
                            }} />}
                            label={<FormattedMessage {...messages.machineRunningStatusRunning} />}
                        />
                        <FormControlLabel
                            value="false"
                            control={<Radio sx={{
                                color: "secondary",
                                '&.Mui-checked': {
                                color: colors.dashbordGreen[500],
                                },
                            }} />}
                            label={<FormattedMessage {...messages.machineRunningStatusStopped} />}
                        />
                    </RadioGroup>
                </FormControl>
                <Tooltip title={<Typography style={{ whiteSpace: 'pre-line' }} fontSize="14px">{formatMessage(messages.minuetesOverThresholdHelpText)}</Typography>} arrow>
                    <IconButton>
                        <InfoIconOutlined />
                    </IconButton>
                </Tooltip>
                <br />
                <Checkbox
                    name="enableLowLimit"
                    label={<FormattedMessage {...messages.enableLowLimit} />}
                    value={props.readingThresholds.enableLowLimit}
                    onChange={handleChange}
                />
                <br />
                <AxionControls.AxionTextBox
                    name="lowLimitValue"
                    label={<FormattedMessage {...messages.lowLimitValue} />}
                    sx={{
                        mt: -2,
                        mb: 1
                    }}
                    value={props.readingThresholds.lowLimitValue}
                    disabled={!props.readingThresholds.enableLowLimit}
                    onChange={handleChange}
                />
                <br />
                <AxionControls.AxionSelect
                    //readOnly={props.recurringSchedule.id > 0}
                    showNoneOption={true}
                    noneText="Ingen vald"
                    noneValue={null}
                    size="small"
                    name="lowLimitInstructionId"
                    disabled={!props.readingThresholds.enableLowLimit}
                    value={props.readingThresholds.lowLimitInstructionId || ""}
                    label={<FormattedMessage {...messages.lowLimitInstruction} />}
                    onChange={handleChangeSelect}
                    options={props.instructionsResult}
                />
                <AxionControls.AxionTextBox
                    name="lowLimitMinutesOverThreshold"
                    label={<FormattedMessage {...messages.lowLimitMinuetesOverThreshold} />}
                    value={props.readingThresholds.lowLimitMinutesOverThreshold}
                    disabled={!props.readingThresholds.enableLowLimit}
                    onChange={handleChange}
                />
                <Checkbox
                    name="lowLimitCheckMachineInStatus"
                    label={<FormattedMessage {...messages.lowLimitCheckMachineInStatus} />}
                    value={props.readingThresholds.enableLowLimit && props.readingThresholds.lowLimitCheckMachineInStatus}
                    disabled={!props.readingThresholds.enableLowLimit}
                    onChange={handleChange}
                />
                <FormControl 
                    disabled={!props.readingThresholds.lowLimitCheckMachineInStatus}
                    sx={{
                        mb: 2
                    }}
                    >
                    <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="lowLimitMachineInRunningStatus"
                        value={!props.readingThresholds.lowLimitCheckMachineInStatus ? "" : props.readingThresholds.lowLimitMachineInRunningStatus}
                        onChange={handleChange}

                    >
                        <FormControlLabel
                            value="true"
                            control={<Radio sx={{
                                color: "secondary",
                                '&.Mui-checked': {
                                color: colors.dashbordGreen[500],
                                },
                            }} />}
                            label={<FormattedMessage {...messages.machineRunningStatusRunning} />}
                        />
                        <FormControlLabel
                            value="false"
                            control={<Radio sx={{
                                color: "secondary",
                                '&.Mui-checked': {
                                color: colors.dashbordGreen[500],
                                },
                            }} />}
                            label={<FormattedMessage {...messages.machineRunningStatusStopped} />}
                        />
                    </RadioGroup>
                </FormControl>
                <Tooltip title={<Typography style={{ whiteSpace: 'pre-line' }} fontSize="14px">{formatMessage(messages.minuetesOverThresholdHelpText)}</Typography>} arrow>
                    <IconButton>
                        <InfoIconOutlined />
                    </IconButton>
                </Tooltip>
                
                <Box>

                    <Button
                        text={<FormattedMessage {...messages.save} />}
                        variant="contained"
                        onClick={props.onThresholdSave}
                    />
                </Box>
            </Box>
        </Box>
    );
}